import React from "react";
import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import styles from "./notes.module.css";
import modalStyle from "./modal.module.css";
import { fullDate } from "../extra/date";
import { checkPassword } from "../extra/checkPassword";
const filterData = (value) => {
  let data = value.toUpperCase();
  let allNotes = document.getElementById("allNotes");
  let eachNote = allNotes.getElementsByClassName("notes_note__No5aQ");
  for (let i = 0; i < eachNote.length; i++) {
    let a = eachNote[i];
    let txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(data) > -1) {
      eachNote[i].style.display = "";
    } else {
      eachNote[i].style.display = "none";
    }
  }
};
const Notes = () => {
  let db = window.data_base;
  const defaultData = {
    title: "",
    desc: "",
  };
  // For thr form
  const [addForm, setAddFrom] = useState(defaultData);
  const [updateForm, setUpdateForm] = useState(defaultData);
  const [valid, setValid] = useState(true);
  const [currentId, setCurrentId] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [display, setDisplay] = useState([]);

  const addData = () => {
    const data = {
      title: addForm.title,
      desc: addForm.desc.replace(/\n/g, "<br/>"),
      date: fullDate,
    };

    const tx = db.transaction("notes", "readwrite");
    const pNotes = tx.objectStore("notes");
    pNotes.add(data);
    setAddModal(false);
    setAddFrom(defaultData);
    showNotes();
  };
  const showNotes = () => {
    setDisplay([]);
    if (db) {
      const tx = db.transaction(["notes"], "readonly");
      const pNotes = tx.objectStore("notes");
      const request = pNotes.openCursor();
      request.onsuccess = (e) => {
        const cursor = e.target.result;
        if (cursor) {
          const note = {
            title: cursor.value.title,
            desc: cursor.value.desc,
            id: cursor.value.id,
            date: cursor.value.date,
          };
          setDisplay((display) => [...display, note].reverse());
          cursor.continue();
        }
      };
    }
  };
  const updateData = () => {
    const data = {
      id: currentId,
      title: updateForm.title,
      desc: updateForm.desc.replace(/\n/g, "<br/>"),
      date: fullDate,
    };
    const tx = db.transaction(["notes"], "readwrite");
    const uNotes = tx.objectStore("notes");
    let request = uNotes.put(data);
    request.onsuccess = () => {
      setUpdateModal(false);
      setUpdateForm(defaultData);
      setCurrentId("");
      showNotes();
    };
  };
  useEffect(() => {
    const dbName = window.dbnewName;
    const dbVersion = window.dbVer;
    const request = indexedDB.open(dbName, dbVersion);
    request.onsuccess = (e) => {
      checkPassword(e.target.result);
      showNotes();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setValid(true);
    if (addForm.title.length > 2 && addForm.desc.length > 5) {
      setValid(false);
    }
  }, [addForm]);

  useEffect(() => {
    setValid(true);
    if (updateForm.title.length > 2 && updateForm.desc.length > 5) {
      setValid(false);
    }
  }, [updateForm]);

  return (
    <div>
      <Navbar active="3" />
      <div className={styles.notesBox}>
        <div className={styles.addBox}>
          <h1>
            Notes <b>({display.length})</b>
          </h1>
          <button
            className={styles.addBtn}
            onClick={() => {
              setAddModal(true);
            }}
          >
            <i className="fa-solid fa-feather-pointed"></i> &nbsp;Add Note
          </button>
        </div>
        <div className={styles.searchBox}>
          <div className={styles.icon}>
            <i className="fa-solid fa-magnifying-glass"></i>
          </div>
          <input
            type="text"
            placeholder="Search Note here..."
            onChange={(ev) => {
              filterData(ev.target.value);
            }}
          ></input>
        </div>
      </div>
      <div className={styles.displayNotes} id="allNotes">
        {display.map((e, index) => (
          <div className={styles.note} key={index}>
            <h1>{e.title}</h1>
            <p className={styles.date}>{e.date}</p>
            <p dangerouslySetInnerHTML={{ __html: e.desc }}></p>

            <div className={styles.footer}>
              <button className={styles.remove}>
                <i
                  className="fas fa-trash"
                  onClick={() => {
                    let transaction = db.transaction(["notes"], "readwrite");
                    let request = transaction.objectStore("notes").delete(e.id);
                    request.onsuccess = () => {
                      showNotes();
                    };
                  }}
                ></i>
              </button>
              <button
                className={styles.edit}
                onClick={() => {
                  setUpdateModal(true);
                  setUpdateForm({
                    title: e.title,
                    desc: e.desc.replace(/<br\/>/g, "\n"),
                  });
                  setCurrentId(e.id);
                }}
              >
                <i className="fas fa-pen"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
      {/* Modal For Update */}
      <div
        className={updateModal ? `${modalStyle.modal}` : `${modalStyle.hide}`}
      >
        <div className={modalStyle.body}>
          <div className={modalStyle.head}>
            <h1>Update Note</h1>
            <div
              className={modalStyle.close}
              onClick={() => {
                setUpdateModal(false);
                setValid(true);
              }}
            >
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <div className={modalStyle.form}>
            <input
              type="text"
              placeholder="Title.."
              onChange={(e) => {
                setUpdateForm({ ...updateForm, title: e.target.value });
              }}
              value={updateForm.title}
            />
            <textarea
              rows="3"
              placeholder="Description here.."
              onChange={(e) => {
                setUpdateForm({ ...updateForm, desc: e.target.value });
              }}
              value={updateForm.desc}
            ></textarea>
            <button disabled={valid} onClick={updateData}>
              Update
            </button>
          </div>
        </div>
      </div>
      {/* Modal for add form */}
      <div className={addModal ? `${modalStyle.modal}` : `${modalStyle.hide}`}>
        <div className={modalStyle.body}>
          <div className={modalStyle.head}>
            <h1>Add Note</h1>
            <div
              className={modalStyle.close}
              onClick={() => {
                setAddModal(false);
              }}
            >
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>

          <div className={modalStyle.form}>
            <input
              type="text"
              placeholder="Title.."
              onInput={(e) => {
                setAddFrom({ ...addForm, title: e.target.value });
              }}
              value={addForm.title}
            />
            <textarea
              rows="3"
              placeholder="Description here.."
              onInput={(e) => {
                setAddFrom({ ...addForm, desc: e.target.value });
              }}
              value={addForm.desc}
            ></textarea>
            <button disabled={valid} onClick={addData}>
              Add Note
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notes;
